import { PhysicianSearchResult } from "../../Shared/Models/PhysicianSearchResult";

export class ClinicalSkill {
    constructor(physicianId: number, trainingProgramId: number) {
        this.inEditMode = true;
        this.physicianId = physicianId;
        this.trainingProgramId = trainingProgramId;
    }

    clinicalSkillId: number;
    clinicalSkillTypeId: number;
    clinicalSkillTypeDescription: string;
    trainingProgramName1: string;
    ownedByTrainingProgramTypeId: number;
    evaluatorName?: string;
    completedDate: string;
    isAttestedComplete: boolean;
    source: string;
    inEditMode: boolean;
    physicianId: number;
    trainingProgramId: number;
    trainingProgramCode: string;
    evaluatorId: number;
    evaluator: PhysicianSearchResult;
    ownedByTrainingProgramId: number;
}

export enum ClinicalSkillType {
    AdultNeurology = 1,
    CAP = 2,
    CapAdolescence = 3,
    CapPreSchool = 4,
    CapSchoolAged = 5,
    ChildNeurology = 6,
    CriticalCare = 7, //LEGACY
    Episodic = 8, //LEGACY
    Neurodegenerative = 9, //LEGACY
    Neuromuscular = 10, //LEGACY
    Psychiatry = 11,
    CriticalCareNeurology =  12,
    EpisodicNeurology = 13,
    NeurodegenerativeNeurology = 14,
    NeuromuscularNeurology = 15,
    CriticalCareChildNeurology = 16,//INACTIVE
    EpisodicChildNeurology = 17,//INACTIVE
    NeurodegenerativeChildNeurology = 18,//INACTIVE
    NeuromuscularChildNeurology = 19,//INACTIVE
    CriticalCareUnderTwoYearsOld = 20,
    CriticalCareTwoToTenYearsOld = 21,
    CriticalCareElevenToEighteenYearsOld = 22,
    EpisodicUnderTwoYearsOld = 23,
    EpisodicTwoToTenYearsOld = 24,
    EpisodicElevenToEighteenYearsOld = 25,
    NeurodegenerativeUnderTwoYearsOld = 26,
    NeurodegenerativeTwoToTenYearsOld = 27,
    NeurodegenerativeElevenToEighteenYearsOld = 28,
    NeuromuscularUnderTwoYearsOld = 29,
    NeuromuscularTwoToTenYearsOld = 30,
    NeuromuscularElevenToEighteenYearsOld = 31
}

export class ClinicalSkillTypeLookup {
    name: string;
    id: number;
    limit: number | null;
    programTypeId: number;
    isActive: boolean;
    evaluatorCertificationIds: Array<number>;
}